const theme = {
  white: '#ffffff',
};

export default theme;
